<template>
  <div class="container page" style="width: 100%;
    background: #fff;">
    <div class="header">
      <van-nav-bar :title="$t('foorter.top32')" class="nav-bar">
        <template #left>
          <van-icon name="arrow-left" color="#000" @click="back()"/>
        </template>
      </van-nav-bar>
    </div><div style="width: 100%;44px;line-height: 44px;font-size: 16px;">
	<div style="display: flex;width: 50%;;float: left;margin-left: 0px;height: 44px;line-height: 44px;">
		<div :class="index1?'act':''" @click="toStatus(1)" style="margin:auto;display: flex;
justify-content: center;height: 44px;line-height: 44px;">{{$t('foorter.top33')}}</div>
	</div><div style="display: flex;width: 50%;;float: right;margin-right: 0px;height: 44px;line-height: 44px;">
		<div :class="index2?'act':''" @click="toStatus(2)" style="margin:auto;display: flex;
justify-content: center;height: 44px;line-height: 44px;">{{$t('foorter.top34')}}</div>
	</div>
	
	</div>
    <div class="content" :style="index1?'display:block':'display:none'">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
          <div class="listItem" v-for="(v,key) in notice" :key="key">
            <div class="listTitle">{{ v.name }}</div>
            <div class="listContent html"><p>{{ v.text }}<br></p></div>
            <div class="listTime"><div class="listTimeText">{{ v.create_time }}</div></div>
          </div>
      </van-pull-refresh>
    </div><div class="content" :style="index2?'display:block':'display:none'">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
          <div class="listItem" v-for="(v,key) in msg" :key="key">
            <div class="listTitle">{{ v.name }}</div>
            <div class="listContent html"><p>{{ v.text }}<br></p></div>
            <div class="listTime"><div class="listTimeText">{{ v.create_time }}</div></div>
          </div>
      </van-pull-refresh>
    </div>
  </div>

</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      notice:{},index1:true,index2:false,msg:{},
      loading: false,
      finished: false,
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    getNoticeList(){
      this.$http({
        method: 'get',
        url: 'sys_get_notice_list'
      }).then(res=>{
        console.log(res);
        this.notice = res.data
      })
    },getMsgList(){
      this.$http({
        method: 'get',
        url: 'sys_get_msg_list'
      }).then(res=>{
        console.log(res);
        this.msg = res.data
      })
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.isLoading = false;
        this.getNoticeList();
      }, 500);
    },toStatus(id) {
      if(id==1){this.index1=true;this.index2=false}if(id==2){this.index1=false;this.index2=true}},
  },
  created() {
    this.getNoticeList();this.getMsgList();
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
::v-deep .van-pull-refresh__track .van-pull-refresh__head *{
  color: #000000;
  font-size: 35px;
}

::v-deep .van-loading__text {
  color: #000000;
  font-size: 35px;
}.act{color: rgb(245, 61, 135);border-bottom: solid #f53d87 3px}
.container .content {
  height: calc(100% - 20px);
  overflow: auto;
  padding-bottom: 40px;
}.nav-bar{background: unset;color:#000}::v-deep  .van-nav-bar__title{color:#000}
.container .content .listItem{
  margin-bottom: 20px;
  padding: 20px 30px 0 30px;
  position: relative;
  color: #000;
  border-bottom: 1px solid #999;
  background-color: #fff;
}
.container .content .listItem .listTitle{
  font-size: 32px;color: #222;
}
.container .content .listItem .listContent{
  border-bottom: 2px solid #f2f2f5;
  text-indent: 2em;
  padding: 5px 0;
  color: #323233;
  font-size: 24px;
}
.container .content .listItem .listTime{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  height: 60px;
}
.container .content .listItem .listTime .listTimeText {
  color: #656566;
  font-size: 30px;
}
</style>
